module.exports = __webpack_public_path__ + "img/ration-right.d616d2f8.svg";